import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

interface TwilioTokenResponse {
  token: string;
  identity: string;
  ttl: number;
}

export function useTwilioToken(enabled = true) {
  const { user } = useAuth();

  return useQuery<TwilioTokenResponse>({
    queryKey: ['twilio-token', user?.id],
    queryFn: async () => {
      const resp = await supabase.functions.invoke('twilio-token');

      if (resp.error) throw new Error(resp.error.message);
      return resp.data as TwilioTokenResponse;
    },
    enabled: !!user?.id && enabled,
    staleTime: 50 * 60 * 1000, // 50 minutes (token TTL is 1hr)
    refetchInterval: 50 * 60 * 1000,
    retry: false, // Don't retry if Twilio isn't configured
  });
}
